import { Component, Prop, h, State, Host, Watch, Element, Event, EventEmitter } from '@stencil/core';
import { LanguageSelectori18n, LanguageSelectorOption } from './pn-language-selector-types';
import { translations } from './translations';
import { globe } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-language-selector',
  styleUrl: 'pn-language-selector.scss',
})
export class PnlanguageSelector {
  @Element() hostElement: HTMLElement;
  /* Current language code  */
  @Prop({ reflect: true, mutable: true }) value: string = '';

  @State() selectedLanguageName = '';
  @State() options: LanguageSelectorOption[] = [];
  @State() i18n: LanguageSelectori18n;

  // Events
  @Event() setLanguage: EventEmitter;

  componentWillLoad() {
    this.setInitialSelectedLanguageName();
    this.setTranslations();
  }

  componentDidLoad() {
    this.initialize();
  }

  initialize() {
    this.setSelectedLanguageName();
    this.addEventBindingsToOptions();
  }

  setInitialSelectedLanguageName() {
    if (!window.Intl || !this.value) {
      return;
    }
    const langs = new (Intl as any).DisplayNames([this.value], { type: 'language' });
    if (!langs) {
      return;
    }
    const languageName = langs.of(this.value);
    if (!languageName) {
      return;
    }
    this.selectedLanguageName = languageName.charAt(0).toUpperCase() + languageName.slice(1);
  }

  addEventBindingsToOptions() {
    const options = [].slice.apply(this.hostElement.querySelectorAll('pn-language-selector-option')) as HTMLElement[];
    options.map((option: HTMLElement) => {
      option.removeEventListener('setCurrentLanguage', (event: CustomEvent) => {
        this.onSetCurrentLanguage(event.detail as LanguageSelectorOption);
      });
      // Bind event listener for when a user change language
      option.addEventListener('setCurrentLanguage', (event: CustomEvent) => {
        this.onSetCurrentLanguage(event.detail as LanguageSelectorOption);
      });
    });
  }

  @Watch('value')
  setSelectedLanguageName() {
    const options = [].slice.apply(this.hostElement.querySelectorAll('pn-language-selector-option')) as HTMLElement[];
    options.map((option: HTMLElement) => {
      // Set current label of language selector
      if (option.getAttribute('code') == this.value) {
        //  || option.getAttribute("selected") == "true"
        this.selectedLanguageName = option.getAttribute('name');
      }
    });
  }

  onSetCurrentLanguage(option: LanguageSelectorOption) {
    this.value = option.code;
    this.selectedLanguageName = option.name;
    this.setLanguage.emit(this.value);
  }

  @Watch('value')
  setTranslations() {
    if (translations[this.value]) {
      this.i18n = translations[this.value] as LanguageSelectori18n;
    }
  }

  @Watch('value')
  onValueChange() {
    const components = this.hostElement.querySelectorAll('pn-language-selector-option') ?? [];
    components.forEach(component => {
      // Pass values as props into slotted components
      // component.setAttribute("current-language", this.value);
      const isSelected = (component.getAttribute('code') === this.value) + '';
      if (component.getAttribute('selected') + '' !== isSelected) {
        component.setAttribute('selected', isSelected);
      }
    });
  }

  render() {
    return (
      <Host value={this.value}>
        <pn-button-dropdown label={this.selectedLanguageName} icon={globe} appearance="light" variant="borderless">
          <div class="languageselector-nav" aria-label={this.i18n.heading}>
            <strong class="languageselector-title">{this.i18n.heading}</strong>
            <div class="languageselector-list" role="list">
              <slot />
            </div>
          </div>
        </pn-button-dropdown>
      </Host>
    );
  }
}
